import { render, staticRenderFns } from "./ProfesorDiaNoDisponible.vue?vue&type=template&id=087b711a"
import script from "./ProfesorDiaNoDisponible.vue?vue&type=script&lang=js"
export * from "./ProfesorDiaNoDisponible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports